/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_MessagesInputs */

const en_portal_nav_messages = /** @type {(inputs: Portal_Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages`)
};

/** @type {(inputs: Portal_Nav_MessagesInputs) => LocalizedString} */
const ar_portal_nav_messages = en_portal_nav_messages;

/** @type {(inputs: Portal_Nav_MessagesInputs) => LocalizedString} */
const he_portal_nav_messages = en_portal_nav_messages;

/** @type {(inputs: Portal_Nav_MessagesInputs) => LocalizedString} */
const ur_portal_nav_messages = en_portal_nav_messages;

/** @type {(inputs: Portal_Nav_MessagesInputs) => LocalizedString} */
const es_portal_nav_messages = en_portal_nav_messages;

/** @type {(inputs: Portal_Nav_MessagesInputs) => LocalizedString} */
const fr_portal_nav_messages = en_portal_nav_messages;

/** @type {(inputs: Portal_Nav_MessagesInputs) => LocalizedString} */
const de_portal_nav_messages = en_portal_nav_messages;

/** @type {(inputs: Portal_Nav_MessagesInputs) => LocalizedString} */
const pt_portal_nav_messages = en_portal_nav_messages;

/** @type {(inputs: Portal_Nav_MessagesInputs) => LocalizedString} */
const hi_portal_nav_messages = en_portal_nav_messages;

/** @type {(inputs: Portal_Nav_MessagesInputs) => LocalizedString} */
const bn_portal_nav_messages = en_portal_nav_messages;

/**
* | output |
* | --- |
* | "Messages" |
*
* @param {Portal_Nav_MessagesInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_nav_messages = /** @type {((inputs?: Portal_Nav_MessagesInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_MessagesInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_nav_messages(inputs)
	if (locale === "he") return he_portal_nav_messages(inputs)
	if (locale === "ur") return ur_portal_nav_messages(inputs)
	if (locale === "es") return es_portal_nav_messages(inputs)
	if (locale === "fr") return fr_portal_nav_messages(inputs)
	if (locale === "de") return de_portal_nav_messages(inputs)
	if (locale === "pt") return pt_portal_nav_messages(inputs)
	if (locale === "hi") return hi_portal_nav_messages(inputs)
	if (locale === "bn") return bn_portal_nav_messages(inputs)
	return /** @type {LocalizedString} */ ("Messages")
});